<template>
  <div class="page-banner purple">
    <div class="content">
      <div class="text">
        <span v-html="textMessage"></span>
      </div>
      <div class="ctas">
        <template v-if="secondaryCta.asDismiss">
          <a
            class="secondary-cta"
            @click.prevent="
              $emit('close');
              $emit('dismiss-promotion', 'page_banner', { dismissed_item: page });
            "
          >
            Don't show again
          </a>
        </template>
        <template v-else>
          <a
            class="secondary-cta"
            :href="secondaryCta.url"
          >
            {{ secondaryCta.text }}
          </a>
        </template>

        <a
          :href="primaryCta.url"
          class="primary-cta btn btn-primary btn-sm"
          @click="$emit('cta-clicked')"
        >
          {{ primaryCta.text }}
        </a>
      </div>
    </div>
    <div class="close-icon">
      <i
        class="hi hi-close hi-10"
        @click="
          $emit('close');
          !secondaryCta.asDismiss && $emit('dismiss-promotion', 'page_banner', { dismissed_item: page });
        "
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppPageBanner',
  props: {
    page: {
      type: String,
      required: true,
    },
    message: {
      type: Object,
      required: true,
    },
    primaryCta: {
      type: Object,
      required: true,
    },
    secondaryCta: {
      type: Object,
      required: true,
    },
    analyticsInfo: {
      type: Object,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    textMessage() {
      const { text, highlight } = this.message;

      if (!highlight) {
        return text;
      }

      const highlighted = `<strong><a href="${highlight.url}" class="highlighted-text" target="_blank">${highlight.text}</a></strong>`;

      return text.replace(highlight.text, highlighted);
    },
  },
};
</script>
